/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  return async function onSubmit({ value, args }) {
    switch (args.type) {
      case 'refetch':
        reExecuteQuery({ requestPolicy: 'network-only' })
        return
      default: {
      }
    }
  }
}
